import { IResponse } from 'src/interface';
import { getWithPath, postWithPath, postWithUrl } from 'src/utils/http';

const API_PATH = {
    GET_USER_ASSETS: '/user/get/assets',
    REPORT: '/user/post/report',
    BOOKMARK: '/user/post/bookmark',
    REMOVE_BOOKMARK: '/user/post/remove-bookmark',
    CLEAR_BOOKMARK: '/user/post/clear-bookmark',
    FOLLOW: '/user/post/follow',
    UNFOLLOW: '/user/post/unfollow',
    POST_CHANNEL: '/user/post/channel',
    GET_CHANNEL: '/user/get/channel',
    REMOVE_CHANNEL: '/user/post/remove-channels',
    REMOVE_HISTORY: '/user/post/remove-history',
    CLEAR_HISTORY: '/user/post/clear-history',
};

export const UserService = {
    getUserAssets: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_USER_ASSETS);
    },
    report: (data: any): Promise<IResponse<any>> => {
        return postWithPath(API_PATH.REPORT, {}, data);
    },
    bookmark: (id: number, isBookmark: boolean): Promise<IResponse<{}>> => {
        return postWithPath(
            isBookmark ? API_PATH.REMOVE_BOOKMARK : API_PATH.BOOKMARK,
            {},
            { id }
        );
    },
    removeBookmark: (id: number): Promise<IResponse<{}>> => {
        return postWithPath(API_PATH.REMOVE_BOOKMARK, {}, { id });
    },
    clearBookmark: (): Promise<IResponse<{}>> => {
        return postWithPath(API_PATH.CLEAR_BOOKMARK, {});
    },
    follow: (
        objectType: string,
        objectId: number,
        isFollow: boolean
    ): Promise<IResponse<{}>> => {
        return postWithPath(isFollow ? API_PATH.UNFOLLOW : API_PATH.FOLLOW, {
            objectType,
            objectId,
        });
    },
    unFollow: (
        objectType: string,
        objectId: number
    ): Promise<IResponse<{}>> => {
        return postWithPath(API_PATH.UNFOLLOW, { objectType, objectId });
    },
    like: (body: { userId: number; id: number }): Promise<any> => {
        return postWithUrl('https://log.baomoi.com/like', {}, body);
    },
    getChannel: (id: string): Promise<any> => {
        return getWithPath(API_PATH.GET_CHANNEL, { id });
    },
    postChannel: (body: any): Promise<any> => {
        return postWithPath(API_PATH.POST_CHANNEL, {}, body);
    },
    removeChannel: (ids: string[]): Promise<any> => {
        return postWithPath(API_PATH.REMOVE_CHANNEL, { ids });
    },
    removeHistory: (id: any): Promise<any> => {
        return postWithPath(API_PATH.REMOVE_HISTORY, { id });
    },
    clearHistory: (): Promise<any> => {
        return postWithPath(API_PATH.CLEAR_HISTORY);
    },
};

export default UserService;
